var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.6665 12.8951V15.7637C4.6665 16.1984 4.82454 16.6153 5.10584 16.9227C5.38715 17.2301 5.76868 17.4028 6.1665 17.4028H15.1665C15.5643 17.4028 15.9459 17.2301 16.2272 16.9227C16.5085 16.6153 16.6665 16.1984 16.6665 15.7637V12.8951M10.6672 3.40283L10.6672 12.6914M10.6672 12.6914L7.23864 9.1423M10.6672 12.6914L14.0958 9.1423",
    stroke: "#33363F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.91cb1463be42edd5b16ebf4f9c6c38e9.svg";
export { ForwardRef as ReactComponent };